/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1DividendAccrualState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_DIVIDEND_ACCRUAL_STATE_ENTITY_NAME = 'ixc.mutualfunds.v1.DividendAccrual';
export const ixcMutualfundsV1DividendAccrualStateEntity = new schema.Entity<IxcMutualfundsV1DividendAccrualState>(IXC_MUTUALFUNDS_V1_DIVIDEND_ACCRUAL_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcMutualfundsV1DividendAccrualState) => `${entity.accountId}-${entity.assetId}-${entity.source}-${entity.firstDayOfMonth}` });

